import PropTypes from 'prop-types';
import { useState } from 'react';
import { createContext } from "react";
import { obtenerCantProductos, obtenerCantProveedores, obtenerDatosParaReporte } from "../services/ReportesService";

export const ReportesContext = createContext();

export default function ReportesContextProvider({ children }) {
    // Fijos
    const [proveedores, setProveedores] = useState(0);
    const [productosVendidos, setProductosVendidos] = useState(0);
    const [productosEnStock, setProductosEnStock] = useState(0);

    // Periodo
    const [ventas, setVentas] = useState([]);

    // Totales vendidos
    const [totalCredito, setTotalCredito] = useState(0);
    const [totalEfectivo, setTotalEfectivo] = useState(0);
    const [totalOtros, setTotalOtros] = useState(0);
    const [totalNotasDeCredito, setTotalNotasDeCredito] = useState(0)
    const [totalSaldosInsuficientes, setTotalSaldosInsuficientes] = useState(0);
    const [totalNotasDeCreditoGeneradas, setTotalNotasDeCreditoGeneradas] = useState(0)
    // Totales devueltos
    const [devCoco, setDevCoco] = useState(0);
    const [devProveedores, setDevProveedores] = useState(0);


    // Ganancias
    const [gananciasCoco, setGananciasCoco] = useState(0);
    const [gananciasProveedores, setGananciasProveedores] = useState(0);

    async function obtenerDatosDelReporte(from, to, local) {
        const data = await obtenerDatosParaReporte(from, to, local);
        let totCredito = 0;
        let totEfectivo = 0;
        let totOtros = 0;
        let devCoco = 0;
        let devProveedores = 0;
        let profitCoco = 0;
        let profitProveedores = 0;
        let totNotaCredito = 0;
        let totSaldoInsuf = 0;
        let totNotaCreditoGeneradas = 0;

        for (const venta of data) {
            totCredito += venta.pagoCredito ? venta.pagoCredito : 0;
            totEfectivo += venta.pagoEfectivo ? venta.pagoEfectivo : 0;
            totOtros += venta.otros ? venta.otros : 0;
            devCoco += venta.devCoco ? venta.devCoco : 0;
            devProveedores += venta.devProveedores ? venta.devProveedores : 0;
            profitCoco += (venta.gananciaCoco >= 0) ? venta.gananciaCoco - venta.devCoco : 0;
            profitProveedores += (venta.gananciaProveedor >= 0) ? venta.gananciaProveedor - venta.devProveedores : 0;
            totNotaCredito += venta.pagadoConNotaCredito ? venta.pagadoConNotaCredito : 0;
            totSaldoInsuf += venta.saldoInsuficiente ? venta.saldoInsuficiente : 0;
            totNotaCreditoGeneradas += venta.precioTotal < 0 ? venta.precioTotal : 0;
        }

        setVentas(data);
        setTotalCredito(totCredito);
        setTotalEfectivo(totEfectivo);
        setTotalOtros(totOtros);
        setDevCoco(devCoco);
        setDevProveedores(devProveedores);
        setGananciasCoco(profitCoco);
        setGananciasProveedores(profitProveedores);
        setTotalNotasDeCredito(totNotaCredito);
        setTotalSaldosInsuficientes(totSaldoInsuf);
        setTotalNotasDeCreditoGeneradas(totNotaCreditoGeneradas);
        // nuevos datos variables
        
        const { vendidos, stock } = await obtenerCantProductos(from, to);
        const totalProveedores = await obtenerCantProveedores(from, to);

        setProveedores(totalProveedores);
        setProductosVendidos(vendidos);
        setProductosEnStock(stock);
    }

    return (
        <ReportesContext.Provider value={{ totalSaldosInsuficientes, ventas, gananciasCoco, gananciasProveedores, devCoco, devProveedores, totalCredito, totalEfectivo, totalOtros, totalNotasDeCredito, totalNotasDeCreditoGeneradas, obtenerDatosDelReporte, proveedores, productosVendidos, productosEnStock }}>
            {children}
        </ReportesContext.Provider>
    )
}

ReportesContextProvider.propTypes = {
    children: PropTypes.element.isRequired,
};